import React, { FC, useCallback, useState, useMemo } from "react"
import { Link, useLocation } from "react-router-dom"
// import { DatePicker } from "antd"
import Env from "@util/env"
import { observer, inject } from "mobx-react"
import "./index.scss"

const tabs = [
  {
    name: "园区洞察",
    key: "/",
  },

  // {
  //   name: "园区图谱",
  //   key: "/graph",
  // },
  {
    name: "智慧园区",
    key: "/park",
  },
]

const Header: FC<any> = ({ store }) => {
  const location = useLocation()
  const [qrCodeVisible, setQrCodeVisible] = useState(false)
  const [isIframe, setisIframe] = useState(false)
  useMemo(() => {
    if (window.self !== window.top) {
      setisIframe(true)
    }
  }, [])
  const exit = useCallback(() => {
    Env.exit()
  }, [])

  return (
    <div className="header">
      <div className="logos">
        <img
          className="logo-ai"
          src={require("../../assets/logo.png")}
          alt=""
        />
        {/* <img
          className="logo-wayz"
          src={require("../../assets/wayz.png")}
          alt="wayz"
        /> */}
      </div>
      <div className="tabs">
        {tabs.map((tab) => {
          return (
            <div
              className={tab.key === location.pathname ? "active" : ""}
              key={tab.key}
            >
              <Link to={tab.key}>{tab.name}</Link>
            </div>
          )
        })}
      </div>
      <div className="btns">
        {isIframe ? (
          <div className="btns-isIframe">
            <div className="btn-phone">
              <img src={require("../../assets/phone.png")} alt="phone" />
              400-166-9938
            </div>
            <div
              className="btn btn-code"
              onClick={() => {
                setQrCodeVisible(!qrCodeVisible)
              }}
            >
              <span>产品与咨询</span>
              <div className={"qrcode" + (qrCodeVisible ? " visible" : "")}>
                <img src={require("../../assets/qrcode.png")} alt="qrcode" />
              </div>
            </div>
            {/* <DatePicker
              defaultValue={store.date}
              disabledDate={store.disabledDate}
              onChange={(date) => {
                store.setDate(date)
              }}
              format="YYYY/MM/DD"
            /> */}
          </div>
        ) : (
          <div className="btn btn-exit" onClick={exit}>
            <span>退出</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default inject("store")(observer(Header))
